module.exports = __webpack_public_path__ + "img/campaign_select_great_vortex.6580f311.png";